import type { GameStateStore } from '../state/GameStateStore';
import type { ItemId } from '../types';

export class InventoryService {
  constructor(private readonly store: GameStateStore) {}

  add(itemId: ItemId): boolean {
    return this.store.addItem(itemId);
  }

  remove(itemId: ItemId): boolean {
    return this.store.removeItem(itemId);
  }

  has(itemId: ItemId): boolean {
    return this.store.snapshot.inventory.includes(itemId);
  }

  select(itemId: ItemId | null): void {
    this.store.update((draft) => {
      draft.selectedItemId = itemId && draft.inventory.includes(itemId) ? itemId : null;
    });
  }
}
